import {BADGE_TRACKING} from '@/consts/badgeTracking';
import eventMessagesService from './eventMessagesService';

const withTrackingValue = (trackingValue: string) => ({
    [BADGE_TRACKING.TRACKING_VALUE_KEY]: trackingValue,
});

export const trackBadgesScreenViewed = () => {
    eventMessagesService.sendAmplitudeTracking({
        eventType: BADGE_TRACKING.EVENT,
        eventStep: BADGE_TRACKING.STEPS.BADGES_SCREEN_VIEWED,
        interactionType: BADGE_TRACKING.INTERACTIONS.SCREEN_VIEWED,
        pageId: BADGE_TRACKING.PAGE_IDS.BADGES,
    });
};

export const trackBadgesInProgressClicked = () => {
    eventMessagesService.sendAmplitudeTracking({
        eventType: BADGE_TRACKING.EVENT,
        eventStep: BADGE_TRACKING.STEPS.BADGES_IN_PROGRESS_CLICKED,
        interactionType: BADGE_TRACKING.INTERACTIONS.BANNER_CLICKED,
        pageId: BADGE_TRACKING.PAGE_IDS.BADGES,
        properties: withTrackingValue(BADGE_TRACKING.TRACKING_VALUES.BADGES_IN_PROGRESS),
    });
};

export const trackBadgesInProgressViewed = (badgeTitles: string[]) => {
    eventMessagesService.sendAmplitudeTracking({
        eventType: BADGE_TRACKING.EVENT,
        eventStep: BADGE_TRACKING.STEPS.BADGES_IN_PROGRESS_VIEWED,
        interactionType: BADGE_TRACKING.INTERACTIONS.SCREEN_VIEWED,
        pageId: BADGE_TRACKING.PAGE_IDS.BADGES_IN_PROGRESS,
        properties: withTrackingValue(badgeTitles.join(', ')),
    });
};

export const trackBadgeClicked = (badgeTitle: string, pageId: string) => {
    eventMessagesService.sendAmplitudeTracking({
        eventType: BADGE_TRACKING.EVENT,
        eventStep: BADGE_TRACKING.STEPS.BADGE_CLICKED,
        interactionType: BADGE_TRACKING.INTERACTIONS.ICON_CLICKED,
        pageId,
        properties: withTrackingValue(badgeTitle),
    });
};

export const trackBadgeOverview = (badgeTitle: string) => {
    eventMessagesService.sendAmplitudeTracking({
        eventType: BADGE_TRACKING.EVENT,
        eventStep: BADGE_TRACKING.STEPS.BADGE_OVERVIEW,
        interactionType: BADGE_TRACKING.INTERACTIONS.SCREEN_VIEWED,
        pageId: BADGE_TRACKING.PAGE_IDS.BADGE_OVERVIEW,
        properties: withTrackingValue(badgeTitle),
    });
};
